module.exports = __webpack_public_path__ + "img/characters.75f96c48.png";